import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  plan: null,
  wplan: null,
  is_open: null,
  comments: []
}

const mutations = {
  SET_PLAN (state, payload) {
    state.plan = payload
  },
  SET_WPLAN (state, payload) {
    state.wplan = payload
  },
  SET_ISOPEN (state, payload) {
    state.is_open = payload
  },
  SET_COMMENTS (state, payload) {
    state.comments = payload
  },
  ADD_COMMENT (state, payload) {
    state.comments.unshift(payload)
  },
  CLEAN (state) {
    state.plan = null
    state.wplan = null
    state.is_open = null
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  }
}

const actions = {
  createPlanCo: (context, data) => {
    return Vue.http.post(`${env.API}/api/plan-con`, data)
      .then((response) => {
        context.commit('SET_PLAN', response.body.message)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  planById: (context, id) => {
    return Vue.http.get(`${env.API}/api/plan-con/${id}`)
      .then((response) => {
        context.commit('SET_PLAN', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  planByWeekCon: (context, data) => {
    return Vue.http.post(`${env.API}/api/plan-con/by-week`, data)
      .then((response) => {
        context.commit('SET_PLAN', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  planUpdate: (context, data) => {
    return Vue.http.put(`${env.API}/api/plan-con/${data.id}`, data)
      .then((response) => {
        context.commit('SET_PLAN', response.body.message)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  closePlanificationStage: (context, data) => {
    return Vue.http.post(`${env.API}/api/plan-con/close`, data)
      .then((response) => {
        context.commit('SET_PLAN', response.body.message)
        return response.body
      })
      .catch((error) => {
        console.log(error)
        return context.commit('API_FAILURE', error)
      })
  },
  planIsOPenByWeek: (context, data) => {
    return Vue.http.post(`${env.API}/api/plan-con/by-week/is-open`, data)
      .then((response) => {
        context.commit('SET_ISOPEN', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  cleanStorePlan: (context) => {
    context.commit('CLEAN')
    return
  },
  generateWeeklyReport: (context, data) => {
    const { week, year } = data
    return Vue.http.get(`${env.API}/api/plan-con/users-report/${week}/${year}`)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getCommentsByPLanConId: (context, id) => {
    return Vue.http.get(`${env.API}/api/plan-con/comments/${id}`)
      .then((response) => {
        context.commit('SET_COMMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  addComment: (context, data) => {
    return Vue.http.post(`${env.API}/api/plan-con/add-comment`, data)
      .then((response) => {
        context.commit('ADD_COMMENT', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        console.log(error)
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getPlan: (state) => state.plan,
  getWPlan: (state) => state.wplan,
  getPlanIsOpen: (state) => state.is_open,
  getComments: (state) => state.comments
}

export const plan_con = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/plan_con.js